module.exports = __webpack_public_path__ + "static/media/sentry-safe-logo@2x.39dd1990.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/sentry-safe-logo@2x.png
// module id = 1305
// module chunks = 0